// extracted by mini-css-extract-plugin
export default {"container":"styles_container__I7GCy","content":"styles_content__sHi7T"};